class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.apply = this.querySelector(".js-filter-apply");
    this.debouncedOnSubmit = debounce((event) => this.onSubmitHandler(event), 500);
    this.apply.addEventListener("click", this.debouncedOnSubmit.bind(this));

    this.addToggleGridListener();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;

      if (searchParams === FacetFiltersForm.searchParamsPrev) return;

      FacetFiltersForm.renderPage(searchParams, null, false);
    };

    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;

    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    if (countContainer) countContainer.classList.add('loading');
    if (countContainerDesktop) countContainerDesktop.classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {html, url}];
        FacetFiltersForm.renderFunctions(html, event);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;

    FacetFiltersForm.renderFunctions(html, event);
  }

  static renderFunctions(html, event) {
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderPagination(html);
    FacetFiltersForm.renderSort(html);
    FacetFiltersForm.triggerAnimations();
  }

  static triggerAnimations() {
    const animations = new Animations();

    if (typeof animations.initializeScrollAnimationTrigger === "function") {
      animations.initializeScrollAnimationTrigger();
    }
  }

  static renderProductGridContainer(html) {
    const columns = document.querySelector(".product-grid").classList.contains("grid--2-col");
    const gridContainer = html.getElementById('ProductGridContainer');

    if (columns) {
      const grid = gridContainer.querySelector(".product-grid");

      grid.classList.add("grid--2-col");
    }

    document.getElementById('ProductGridContainer').innerHTML = gridContainer.innerHTML;
  }

  static renderProductCount(html) {
    const count = html.getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerSticky = document.getElementById('ProductCountSticky');

    container.innerHTML = count;
    container.classList.remove('loading');

    if (containerSticky) {
      containerSticky.innerHTML = count;
      containerSticky.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const facetDetailsElements = html.querySelectorAll('#FacetFiltersForm .js-filter');

    const matchesIndex = element => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;

      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };

    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const facet = element.querySelector(".filters__list");
      const target = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      const list = target.querySelector(".filters__list:not(.js-filter-price)");

      if (list && facet) list.innerHTML = facet.innerHTML;
    });

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({searchParams}, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static renderPagination(html) {
    const pagination = html.querySelector('.js-pagination');

    if (pagination) document.querySelector('.js-pagination').replaceWith(pagination);
  }

  static renderSort(html) {
    const radios = html.querySelectorAll(".filters__radio");
    const oldRadios = document.querySelectorAll(".filters__radio");

    oldRadios.forEach((oldRadio, index) => oldRadio.innerHTML = radios[index].innerHTML);
  }

  static getSections() {
    return [{ section: document.getElementById('product-grid').dataset.id }];
  }

  createSearchParams(form) {
    const formData = new FormData(form);

    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const form = document.getElementById('FacetFiltersForm');
    const noJsElements = document.querySelectorAll('.no-js-list');

    noJsElements.forEach(el => el.remove());

    this.onSubmitForm(this.createSearchParams(form), event);

    publish(PUB_SUB_EVENTS.closeFilterDrawer);
  }

  onActiveFilterClick(event) {
    event.preventDefault();

    FacetFiltersForm.toggleActiveFacets();

    const href = event.currentTarget.href;
    const url = href.indexOf('?') === -1 ? '' : href.slice(href.indexOf('?') + 1);

    FacetFiltersForm.renderPage(url);

    if (
      event.currentTarget.classList.contains("filters__clear") ||
      event.currentTarget.classList.contains("filters__button")
    ) {
      publish(PUB_SUB_EVENTS.closeFilterDrawer);
    }
  }

  addToggleGridListener() {
    const iconSquare = document.querySelector(".filters__icons .icon--single-view");
    const iconGrid = document.querySelector(".filters__icons .icon--split-view");
    const isTablet = window.matchMedia("(min-width: 750px) and (max-width: 989px)").matches;

    iconGrid.classList.add("icon--active");

    iconSquare.addEventListener("click", () => {
      if (!iconSquare.classList.contains("icon--active")) {
        iconSquare.classList.toggle("icon--active");
        iconGrid.classList.toggle("icon--active");

        document.querySelector(".js-product-grid").classList.replace("grid--2-col", "grid--1-col");
      }
    });

    iconGrid.addEventListener("click", () => {
      if (!iconGrid.classList.contains("icon--active")) {
        iconGrid.classList.toggle("icon--active");
        iconSquare.classList.toggle("icon--active");

        document.querySelector(".js-product-grid").classList.replace("grid--1-col", "grid--2-col");
      }
    });

    if (isTablet) {
      iconSquare.classList.remove("icon--active");
      iconGrid.classList.add("icon--active");

      document.querySelector(".js-product-grid").classList.replace("grid--1-col", "grid--2-col");
    }
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.setListeners();

customElements.define('facet-filters-form', FacetFiltersForm);

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.activeFilter = this.querySelector(".filters__item--active");

    this.addFakeRadioListeners();
  }

  addFakeRadioListeners() {
    const radios = this.querySelectorAll(".js-radio");
    const inputs = this.querySelectorAll(".js-radio-input");

    radios.forEach(radio => radio.addEventListener("click", () => {
      if (radio.classList.contains("filter__item--active")) return;

      this.updateRadio(radio, inputs);
    }));
  }

  updateRadio(radio, inputs) {
    const min = radio.dataset.min;
    const max = radio.dataset.max;

    inputs[0].value = min;
    inputs[1].value = max;

    radio.classList.add("filters__item--active");

    this.activeFilter.classList.remove("filters__item--active");
    this.activeFilter = radio;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();

    const facetLink = this.querySelector('a');

    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();

      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();

    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
